<template>
  <app-main-layout>
    <!--  -->
    <!--  -->
    <template v-slot:left>
      <app-left-nav />
    </template>
    <!--  -->
    <template v-slot:bottom-nav>
      <app-bottom-nav />
    </template>
    <!--  -->
    <!--  -->
    <template v-slot:top>
      <app-top-nav padded>
        <template v-slot:left>
          <el-button
            v-if="false"
            type="text"
            plain
            circle
            is-all-borderless
            icon="el-icon-back"
          />
        </template>
        <!--  -->
        <template v-slot:center>
          <span nav-title>Transactions</span>
        </template>
        <!--  -->
        <template v-slot:right> </template>
        <!--  -->
        <template v-slot:bottom>
          <el-menu router mode="horizontal">
            <el-menu-item index="/transactions">
              <el-icon>
                <checked />
              </el-icon>
              <span>All</span>
            </el-menu-item>
            <el-menu-item index="/transactions?status=succeeded">
              <el-icon>
                <star />
              </el-icon>
              <span>Succeeded</span>
            </el-menu-item>
            <el-menu-item index="/transactions?status=processing">
              <el-icon>
                <Refresh />
              </el-icon>
              <span>Processing</span>
            </el-menu-item>
          </el-menu>
        </template>
      </app-top-nav>
    </template>
    <!--  -->
    <template v-slot:middle>
      <!--  -->
      <!-- Loaded transactions -->
      <div>
        <transasctionsList :transactions="transactions"></transasctionsList>
        <!--  -->
        <app-loader-transactions
          :loading="loading"
          :resources="transactions"
          content="Can't find any transactions."
        />
        <!--  -->
      </div>
    </template>
    <!--  -->
    <template v-slot:right>
      <app-right-nav>
        <app-business-right-nav />
      </app-right-nav>
    </template>
    <!--  -->
    <!--  -->
  </app-main-layout>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import transasctionsList from "./components/transactions-list-component.vue";
import { Checked, Star, Refresh } from "@element-plus/icons";
@Options({
  components: { transasctionsList, Checked, Star, Refresh },
})
export default class extends Vue {
  /**
   * @returns created transactions
   */
  get transactions() {
    return this.$store.state.transactions.transactions;
  }

  /**
   * @returns the loading state of the created transactions
   */
  get loading() {
    return this.$store.state.transactions.loading;
  }

  mounted() {
    this.$store.dispatch("transactions/fetch");
  }
}
</script>

<style lang="scss"></style>
